
import { defineComponent } from 'vue';
import { AxiosError } from "axios";

interface State {
  loginStatus: boolean;
  loginError: boolean;
  user: string;
  password: string;
  errors: AxiosError[]
}

export default defineComponent({
  name: 'Login',

  data: (): State => {
    return {
      loginStatus: false,
      loginError: false,
      user: '',
      password: '',
      errors: []
    }
  },
  methods: {
    callLogin() {
      this.errors = [];
      this.$store.dispatch("login", { user: this.user, password: this.password})
        .then(response => {
          this.loginStatus = true;
          this.loginError = false;
          this.$store.dispatch("maintainAuthToken", { token: response.data.Token })
          this.$router.push('/')
        })
        .catch((error: AxiosError) => {
          this.loginStatus = false;
          this.loginError = true;
          this.errors.push(error);
        })
    }
  }
});
